import React, { memo } from 'react'
import { ICellRendererParams } from 'ag-grid-community'
import { AgGridRowResizeDragger } from '../../../dragger/rowResizeDragger'

type Props = ICellRendererParams & {
  switchRootWbsItem: (event: MouseEvent, rootProjectPlanUuid?: string) => void
  onChangeRowSize?: (rowHeight: number) => void
}

export const ProjectPlanSequenceNoCellRenderer = memo(
  ({
    node,
    api,
    context,
    data,
    value,
    switchRootWbsItem,
    onChangeRowSize,
  }: Props) => {
    const rowNumber = value
    const projectPlanUuid = data?.uuid
    const isLink = !data?.added

    return (
      <div className="sevend-ag-cell-sequence-no">
        {isLink && (
          <a
            className="sevend-ag-cell-sequence-no__link"
            onClick={event => {
              switchRootWbsItem(event as unknown as MouseEvent, projectPlanUuid)
            }}
          >
            {rowNumber}
          </a>
        )}
        {!isLink && (
          <p className="sevend-ag-cell-sequence-no__label">{rowNumber}</p>
        )}
        {!context?.isRowHeightFixed && (
          <AgGridRowResizeDragger
            node={node}
            api={api}
            onChangeRowSize={onChangeRowSize}
          />
        )}
      </div>
    )
  },
  // カスタム比較関数
  (prevProps, nextProps) => {
    if (prevProps.value !== nextProps.value) return false
    if (prevProps.data?.added !== nextProps.data?.added) return false
    if (prevProps.data?.uuid !== nextProps.data?.uuid) return false
    if (
      prevProps.context?.isRowHeightFixed !==
      nextProps.context?.isRowHeightFixed
    ) {
      return false
    }
    return true
  }
)
